<template>
    <div class="mainContainer">
        <Banner/>
        <div class="listContainer w11 mtop40">
            <!-- 书法课堂 -->
            <learn-module>
                <learn-sort>
                    <img src="~assets/images/temporary/sortImg1-1.png" alt="" class="sortImg" slot="sortImg">
                    <p slot="sortText">书法课堂</p>
                </learn-sort>
                <learn-list routeSort="university">
                    <learn-item v-for="i in 8" :key="i">
                        <img src="~assets/images/temporary/sortImg1-1-1.png" alt=""  slot="learn-item-img">
                        <p class="ellipsis" slot="learn-item-text">认知汉字结构</p>
                    </learn-item>
                </learn-list>
            </learn-module>
            <!-- 绘画学院 -->
            <learn-module>
                <learn-sort>
                    <img src="~assets/images/temporary/sortImg1-2.png" alt="" class="sortImg" slot="sortImg">
                    <p slot="sortText">绘画学院</p>
                </learn-sort>
                <learn-list>
                    <learn-item v-for="i in 8" :key="i">
                        <img src="~assets/images/temporary/sortImg1-1-2.png" alt=""  slot="learn-item-img">
                        <p class="ellipsis" slot="learn-item-text">认知汉字结构</p>
                    </learn-item>
                </learn-list>
            </learn-module>
            <!-- 音乐学院 -->
            <learn-module>
                <learn-sort>
                    <img src="~assets/images/temporary/sortImg1-3.png" alt="" class="sortImg" slot="sortImg">
                    <p slot="sortText">音乐学院</p>
                </learn-sort>
                <learn-list>
                    <learn-item v-for="i in 8" :key="i">
                        <img src="~assets/images/temporary/sortImg1-1-3.png" alt=""  slot="learn-item-img">
                        <p class="ellipsis" slot="learn-item-text">认知汉字结构</p>
                    </learn-item>
                </learn-list>
            </learn-module>
            <!-- 舞蹈学院 -->
            <learn-module>
                <learn-sort>
                    <img src="~assets/images/temporary/sortImg1-4.png" alt="" class="sortImg" slot="sortImg">
                    <p slot="sortText">舞蹈学院</p>
                </learn-sort>
                <learn-list>
                    <learn-item v-for="i in 8" :key="i">
                        <img src="~assets/images/temporary/sortImg1-1-4.png" alt=""  slot="learn-item-img">
                        <p class="ellipsis" slot="learn-item-text">认知汉字结构</p>
                    </learn-item>
                </learn-list>
            </learn-module>
            <!-- 健康学院 -->
            <learn-module>
                <learn-sort>
                    <img src="~assets/images/temporary/sortImg1-5.png" alt="" class="sortImg" slot="sortImg">
                    <p slot="sortText">健康学院</p>
                </learn-sort>
                <learn-list>
                    <learn-item v-for="i in 8" :key="i">
                        <img src="~assets/images/temporary/sortImg1-1-5.png" alt=""  slot="learn-item-img">
                        <p class="ellipsis" slot="learn-item-text">认知汉字结构</p>
                    </learn-item>
                </learn-list>
            </learn-module>
            <!-- 烹饪学院 -->
            <learn-module>
                <learn-sort>
                    <img src="~assets/images/temporary/sortImg1-6.png" alt="" class="sortImg" slot="sortImg">
                    <p slot="sortText">烹饪学院</p>
                </learn-sort>
                <learn-list>
                    <learn-item v-for="i in 8" :key="i">
                        <img src="~assets/images/temporary/sortImg1-1-6.png" alt=""  slot="learn-item-img">
                        <p class="ellipsis" slot="learn-item-text">认知汉字结构</p>
                    </learn-item>
                </learn-list>
            </learn-module>
            <!-- 摄影学院 -->
            <learn-module>
                <learn-sort>
                    <img src="~assets/images/temporary/sortImg1-7.png" alt="" class="sortImg" slot="sortImg">
                    <p slot="sortText">摄影学院</p>
                </learn-sort>
                <learn-list>
                    <learn-item v-for="i in 8" :key="i">
                        <img src="~assets/images/temporary/sortImg1-1-7.png" alt=""  slot="learn-item-img">
                        <p class="ellipsis" slot="learn-item-text">认知汉字结构</p>
                    </learn-item>
                </learn-list>
            </learn-module>
        </div>
    </div>
</template>

<script>
import Banner from "views/PcViews/Learn/University/Index/Banner"
import LearnModule from "components/contents/learnModule/LearnModule"
import LearnList from "components/contents/learnList/LearnList"
import LearnSort from "components/common/learnSort/LearnSort"
import LearnItem from "components/common/learnItem/LearnItem"
export default {
    components:{ Banner, LearnModule, LearnList, LearnSort, LearnItem },
    data(){
        return {

        }
    }
}
</script>

<style lang="less" scoped>
.listContainer{
    overflow: hidden;
}
</style>
